'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cart = require('ifeis-isomorphic/lib/redux/actions/cart');

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _getRegistrations = require('ifeis-isomorphic/lib/redux/actions/registrations/getRegistrations');

var _getRegistrations2 = _interopRequireDefault(_getRegistrations);

var _setRegistrationNumber = require('ifeis-isomorphic/lib/redux/actions/registrations/setRegistrationNumber');

var _setRegistrationNumber2 = _interopRequireDefault(_setRegistrationNumber);

var _index = require('ifeis-isomorphic/lib/redux/actions/cart/index');

var _getProducts = require('ifeis-isomorphic/lib/redux/actions/products/getProducts');

var _getPurchasedProductsByAccount2 = require('ifeis-isomorphic/lib/redux/actions/products/getPurchasedProductsByAccount');

var _index2 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/index');

var _getEvents = require('ifeis-isomorphic/lib/redux/actions/events/getEvents');

var _getEvents2 = _interopRequireDefault(_getEvents);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegistrationsProductsController = function () {
  function RegistrationsProductsController(fPrompt, fCashCollectDialog, fPaymentHistoryDialog, $scope, $q, $mdDialog, $attrs, fSession, $mdComponentRegistry, msgService, $state, $ngRedux, fPrintCompCards) {
    var _this = this;

    _classCallCheck(this, RegistrationsProductsController);

    this._ = {
      fPrompt: fPrompt,
      fCashCollectDialog: fCashCollectDialog,
      fPaymentHistoryDialog: fPaymentHistoryDialog,
      fSession: fSession,
      $mdDialog: $mdDialog,
      $q: $q,
      $scope: $scope,
      msgService: msgService,
      $state: $state,
      $ngRedux: $ngRedux,
      fPrintCompCards: fPrintCompCards
    };

    this.allowRegistration = false;
    this.now = new Date().getTime();

    $scope.$watch(function () {
      return _this.roles;
    }, function (roles) {
      _this.allowRegistration = angular.isDefined($attrs.allowRegistration) && $attrs.allowRegistration !== 'false' && !_this.feis.is_finalized && (_this.now < _this.feis.dt_reg_end || _this.hasRole('registration')) ? true : false;
    });

    $mdComponentRegistry.when('registrations-products-sidenav').then(function (it) {
      $scope.$watch(function () {
        return it.isOpen();
      }, function (open) {
        if (open) {
          _this.currentTabIdx = 0;
          _this.getBalance();
          _this.getRegistrations();
          _this.getPurchasedProductsByAccount();
          _this.getEvents();
          _this.getFeisProducts();
          var mapProductsAndRegistrations = (0, _mapStateToController2.default)(_this.feis, _this.person);
          _this._.$ngRedux.connect(function (state) {
            return mapProductsAndRegistrations(state);
          })(_this);
        }
      });
    });
  }

  _createClass(RegistrationsProductsController, [{
    key: 'hasRole',
    value: function hasRole(role) {
      if (this._.fSession.isGod()) {
        return true;
      }

      if (!this.roles) {
        return false;
      }

      return this.roles.indexOf('chair') !== -1 || this.roles.indexOf(role) !== -1;
    }

    /**
     * Competitor Number
     */

  }, {
    key: 'editCompetitorNumber',
    value: function editCompetitorNumber($event) {
      var _this2 = this;

      return this._.fPrompt({
        title: 'Change Competitor Number',
        label: 'Number',
        value: this.person.competitor,
        action: 'Change',
        type: 'number'
      }, $event).then(function (num) {
        if (num !== _this2.person.competitor) {
          _this2._.$ngRedux.dispatch((0, _setRegistrationNumber2.default)(_this2.feis.id, _this2.person.id, { num: parseInt(num, 10) }));
        }
      }).catch(function (err) {
        return _this2._.msgService.displayErrorMsg('Update failed: ' + err.data.errors[0].detail);
      });
    }
  }, {
    key: 'printCompetitorCard',
    value: function printCompetitorCard() {
      if (this.person.competitor) {
        this._.fPrintCompCards(this.feis.id, this.person);
      } else {
        this._.msgService.displayErrorMsg('Competitor number for this person is not yet assigned.');
      }
    }
  }, {
    key: 'addCredit',
    value: function addCredit($event) {
      var _this3 = this;

      this._.fCashCollectDialog({ value: this.feisAccountBalances.get('balance') > 0 ? this.feisAccountBalances.get('balance') : 0.00 }, $event).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            amount = _ref2[0],
            description = _ref2[1];

        return _this3._.$ngRedux.dispatch((0, _index2.payAccountBalance)(_this3.feis.id, _this3.account.get('id'), { amount: amount, stripe_token: null, description: description, currency: _this3.feis.currency })).catch(function (err) {
          return _this3._.msgService.displayErrorMsg(err);
        });
      });
    }
  }, {
    key: 'withAccount',
    value: function withAccount(person_id) {
      return person_id && this._.$ngRedux.dispatch((0, _accounts.getAccountForPerson)(person_id)) || Promise.resolve();
    }
  }, {
    key: 'getBalance',
    value: function getBalance() {
      var _this4 = this;

      return this.withAccount(this.person.id).then(function (account) {
        var accountId = account.account && account.account.get('acct_id');
        _this4._.$ngRedux.dispatch((0, _cart.updateCart)(_this4.feis.id, accountId, true));
      });
    }
  }, {
    key: 'getRegistrations',
    value: function getRegistrations() {
      var _this5 = this;

      this.registrations = [];

      return this._.$ngRedux.dispatch((0, _getRegistrations2.default)(this.feis.id, this.person.id)).catch(function (err) {
        return _this5._.msgService.displayErrorMsg(err);
      });
    }

    /**
     * Search events
     */

  }, {
    key: 'getEvents',
    value: function getEvents(filter) {
      var _this6 = this;

      return this._.$ngRedux.dispatch((0, _getEvents2.default)(this.feis.id, { age: this.person.$feisAge === 'n/a' ? undefined : this.person.$feisAge, filter: filter })).catch(function (err) {
        return _this6._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'getFeisProducts',
    value: function getFeisProducts() {
      var _this7 = this;

      return this._.$ngRedux.dispatch((0, _getProducts.getProducts)(this.feis.id)).catch(function (err) {
        return _this7._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'getPurchasedProductsByAccount',
    value: function getPurchasedProductsByAccount() {
      var _this8 = this;

      return this.withAccount(this.person.id).then(function (account) {
        var accountId = account.account && account.account.get('acct_id');
        return _this8._.$ngRedux.dispatch((0, _getPurchasedProductsByAccount2.getPurchasedProductsByAccount)(_this8.feis.id, accountId)).catch(function () {
          return _this8.msgService.displayErrorMsg('Could not get purchased products');
        });
      });
    }

    /**
     * Products
     */

  }, {
    key: 'registerProduct',
    value: function registerProduct(product_id) {
      var _this9 = this;

      if (!product_id) {
        return;
      }
      return this._.$ngRedux.dispatch((0, _cart.purchaseProduct)(this.feis.id, this.account.get('id'), product_id)).catch(function (err) {
        return _this9.msgService.displayErrorMsg('Could not add to cart');
      });
      ;
    }
  }, {
    key: 'unRegisterProduct',
    value: function unRegisterProduct(productId) {
      if (!productId) {
        return;
      }
      return this._.$ngRedux.dispatch((0, _cart.returnProduct)(this.feis.id, this.account.get('id'), productId));
    }

    /**
     * Registration
     */

  }, {
    key: 'register',
    value: function register(event) {
      var _this10 = this;

      if (!event) {
        return;
      }

      return this._.$ngRedux.dispatch((0, _index.registerForEvent)(this.feis.id, event.id, this.account.get('id'), this.person.id)).catch(function (err) {
        return _this10._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'unregister',
    value: function unregister(eventId) {
      var _this11 = this;

      if (!eventId) {
        return;
      }
      return this._.$ngRedux.dispatch((0, _index.unregisterForEvent)(this.feis.id, eventId, this.account.get('id'), this.person.id)).catch(function (err) {
        return _this11._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'openPaymentsDialog',
    value: function openPaymentsDialog(ev) {
      this._.fPaymentHistoryDialog(ev, this.account, this.feis).then(function () {});
    }
  }, {
    key: 'getEventName',
    value: function getEventName(ev) {
      if (ev) {
        return (0, _ifeisIsomorphic.getDescription)(ev);
      }
    }
  }, {
    key: 'searchProductsMatch',
    value: function searchProductsMatch(searchText) {
      return this.products.filter(function (product) {
        return product.description && product.description.toLowerCase().match(searchText.toLowerCase());
      });
    }
  }, {
    key: 'searchEventsMatch',
    value: function searchEventsMatch(searchText) {
      return this.eventsForFeis.filter(function (ev) {
        return (0, _ifeisIsomorphic.getDescription)(ev).toLowerCase().match(searchText.toLowerCase());
      });
    }
  }, {
    key: 'setCurrentTabIndex',
    value: function setCurrentTabIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.currentTabIdx = index;
    }
  }, {
    key: 'goTo',
    value: function goTo(state, id) {
      this._.$state.go(state, { participant: id, feis: this.feis });
    }
  }]);

  return RegistrationsProductsController;
}();

exports.default = angular.module('ifeis.registrations-products-sidenav', ['ngMaterial']).directive('fRegistrationsProductsSidenav', function () {
  return {
    controller: RegistrationsProductsController,
    controllerAs: 'productsAndRegistrations',
    bindToController: true,
    template: require('./tpl.html'),
    restrict: 'E',
    transclude: true,
    scope: {
      person: '=',
      feis: '=',
      roles: '=',
      open: '=?',
      eventId: '=?'
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./registrations-products-sidenav/index.js
// module id = 503
// module chunks = 0